/* MOBILE BUTTONS */
var readMoreButtonMb = document.querySelector('.read-more-button-mb');
readMoreButtonMb.addEventListener('click', function(event) {
  event.preventDefault();
  var descriptionFullMobile = document.querySelector('.collection-hero__description.mobile-only');
  descriptionFullMobile.classList.toggle("truncate")
  var descriptionFullDesktop = document.querySelector('.collection-hero__description.desktop-only');
  descriptionFullDesktop.classList.toggle("truncate");
  this.style.display = 'none';
  document.querySelector('.read-less-button-mb').style.display = 'block';
});

var readLessButtonMb = document.querySelector('.read-less-button-mb');
readLessButtonMb.addEventListener('click', function(event) {
  event.preventDefault();
  var descriptionFullMobile = document.querySelector('.collection-hero__description.mobile-only');
  descriptionFullMobile.classList.toggle("truncate")
  var descriptionFullDesktop = document.querySelector('.collection-hero__description.desktop-only');
  descriptionFullDesktop.classList.toggle("truncate");
  this.style.display = 'none';
  document.querySelector('.read-more-button-mb').style.display = 'block';
});  